import { IAsset } from "@api/IWalletController";
import { create } from "zustand";

export interface NewToken {
    id: number;
    guid: string;
    devWallet?: string | null;
    asset1?: string | IAsset | null;
    asset2?: string | IAsset | null;
    tokenOrPoolAddress: string;
    dex: string;
    deployAmount?: number | null;
    devDeployHistoryTonBalance?: number | null;
    devDeployHistoryJettonBalance?: number | null;
    devDeployCount?: number | null;
    price?: number | null;
    marketCap?: number | null;
    liquidity?: number | null;
    deployedAt: string;
    createdAt: string;
    updatedAt: string;
}

interface IDeploysStore {
    history: NewToken[];
    isLoading: boolean;
    error: string | null;
    isWebSocketConnected: boolean;
    addToken: (newToken: NewToken) => void;
    removeToken: (guid: string) => void;
    fetchHistory: () => Promise<void>;
    clearHistory: () => void;
    initWebSocket: () => void;
    closeWebSocket: () => void;
    updateToken: (updatedToken: NewToken) => void;
}

export const useDeploysStore = create<IDeploysStore>((set, get) => {
    let ws: WebSocket | null = null;
    let isFirstConnection = true;
    let reconnectTimeoutId: number | null = null;

    return {
        history: [],
        isLoading: false,
        error: null,
        isWebSocketConnected: false,

        fetchHistory: async () => {
            try {
                set({ isLoading: true });
                // const response = await fetch(...);
                // set({ history: response.data });
            } catch (error: any) {
                set({ error: error.message });
            } finally {
                set({ isLoading: false });
            }
        },

        clearHistory: () => {
            set({ history: [], error: null });
        },

        initWebSocket: () => {
            // Если сокет уже открыт или открывается/закрывается — выходим
            if (ws && ws.readyState !== WebSocket.CLOSED) {
                return;
            }

            // Закрываем «старый» сокет, если остался
            if (ws) {
                ws.close();
            }

            ws = new WebSocket("wss://dev-api.nestdex.io/v2/websocket/connect");

            ws.onopen = () => {
                set({ isWebSocketConnected: true });

                if (isFirstConnection) {
                    ws!.send(JSON.stringify({ event: "deploys", data: "last-30" }));
                    isFirstConnection = false;
                }
            };

            ws.onmessage = ({ data }) => {
                try {
                    const message = JSON.parse(data);
                    if (Array.isArray(message)) {
                        set({ history: message });
                    } else if (message.event === "deploys" && message.data) {
                        set((state) => ({ history: [message.data, ...state.history] }));
                    }
                } catch (err) {
                    console.error("Ошибка парсинга WebSocket:", err);
                    set({ error: "Ошибка обработки данных WebSocket" });
                }
            };

            ws.onclose = () => {
                set({ isWebSocketConnected: false });
                ws = null;

                // Реконнект
                if (reconnectTimeoutId !== null) {
                    clearTimeout(reconnectTimeoutId);
                }
                reconnectTimeoutId = window.setTimeout(() => {
                    reconnectTimeoutId = null;
                    get().initWebSocket();
                }, 5000);
            };

            ws.onerror = (err) => {
                console.error("WebSocket ошибка:", err);
                // Закрываем и надеемся на onclose + авто-реконнект
                ws?.close();
            };
        },

        closeWebSocket: () => {
            if (reconnectTimeoutId !== null) {
                clearTimeout(reconnectTimeoutId);
                reconnectTimeoutId = null;
            }
            ws?.close();
            ws = null;
            set({ isWebSocketConnected: false });
        },
        addToken: (newToken) => {
            set((state) => ({ history: [...state.history, newToken] }));
        },
        removeToken: (guid) => {
            set((state) => ({
                history: state.history.filter((token) => token.guid !== guid),
            }));
        },
        updateToken: (updatedToken: NewToken) => {
            set((state) => ({
                history: state.history.map((token) => (token.guid === updatedToken.guid ? updatedToken : token)),
            }));
        },
    };
});
